/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

/**
 * Initialization of app router and store is done using explicit function calls rather than using
 * the singleton pattern, providing the following benefits:
 * - Potential cyclic dependencies are avoided
 * - Direct imports of the router or the store in components are thus not possible
 * - Mocking these in tests is easier
 */

import { sync } from 'vuex-router-sync';
import { createRouter, addRoutes, registerNavigationGuards } from './router';
import { createStore } from './state/store';

const router = createRouter();
const store = createStore(router);
const unsync = sync(store, router);

function init() {
  if (!store.state.initialized) {
    store.dispatch('initialize');
  }
}

addRoutes(router, store);
registerNavigationGuards(router, store);
init();

export { store, router, unsync };
